import styled from '@emotion/styled';

import COLORS from '../../styles/emotion/colors3';
import { FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const FAQItemWrapper = styled.div`
  width: 100%;
  margin-bottom: ${SPACING.LG};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    margin-bottom: ${SPACING.S24};
  }
`;

export const Question = styled.h4`
  color: ${COLORS.WHITE_100};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 0 0 ${SPACING.SM};
  letter-spacing: normal;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    font-size: ${FONT.FONT_SIZE_REGULAR};
    margin-bottom: ${SPACING.S16};
  }
`;

export const Answer = styled.p`
  color: ${COLORS.WHITE_100};
`;
